import EventTracker from '~/lib/event_tracker';
import { TRACKER_READY_EVENT } from '~/lib/feature_tracking';

// JS-12 sign-off: SiteConfig/_sktrk/SK.EventTracking are the contract between
// server-rendered inline scripts and this bundle — layouts/_event_tracker.html.erb
// seeds SiteConfig.EventTracker and the _sktrk queue (R-7/R-8 sign-off recorded
// there), and event_tracker_helper.rb renders inline `_sktrk.push` snippets that
// call SK.EventTracking.*. Inline scripts can't import modules; window is the seam.
// eslint-disable-next-line no-restricted-syntax -- JS-12: server-inline contract, see above
window.SiteConfig = window.SiteConfig || {};
// eslint-disable-next-line no-restricted-syntax -- JS-12: server-inline contract, see above
window.SK = window.SK || {};

const tracker = new EventTracker({
  ...window.SiteConfig.EventTracker,
  props: window._sktrk || [],
});

// It must be initialized after the global variable assignment.
window.SK.EventTracking = tracker;
tracker.init();

// Behaviors are not ordered against this entrypoint, and anything that tracks
// during behavior init (a `?g=&i=` gallery deep link opens the viewer right away)
// would otherwise find no tracker and be dropped — `window._sktrk` is already
// consumed by the constructor above. lib/feature_tracking buffers those calls and
// flushes them here. EventTracker queues internally from this point on, so it is
// safe to announce before Amplitude has finished loading.
document.dispatchEvent(new CustomEvent(TRACKER_READY_EVENT));

// The legacy `sk_special_offer:modal:track` handler that used to sit here is
// gone: it bound to SK.Helpers.vent (the Backbone aggregator), which v2 does not
// have, so it could never fire. Its work — the `specialOffer` user property, the
// `specialOfferCount` increment and `Feature: Special Offer Modal` — now happens
// in behaviors/so_parallax.js#trackOfferViewed, at the same moment legacy fired
// it (the parallax becoming ready). Parity validation P-9c, 2026-08-03.
